import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from "react";
import { Divider, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme, } from "@mui/material";
import { useCloseAppDrawer } from "./AppDrawerContext.js";
/**
 * A list item for the application drawer consisting of an icon and text.
 *
 * Pass `component` to render it as something other than a button — a router's
 * link, say — with that element's own props alongside. Activating an item also
 * closes a temporary drawer, so a consumer never has to.
 */
export const AppDrawerListItem = ({ icon, text, hoverColor, selectedColor, onClick, ...buttonProps }) => {
    const theme = useTheme();
    const closeDrawer = useCloseAppDrawer();
    return (_jsx(ListItem, { disablePadding: true, children: _jsxs(ListItemButton, { ...buttonProps, onClick: () => {
                onClick?.();
                closeDrawer();
            }, sx: {
                ...(hoverColor === undefined
                    ? {}
                    : {
                        "&:hover": { backgroundColor: hoverColor },
                        "&:focus-visible": {
                            backgroundColor: hoverColor,
                            outline: `1px dotted ${theme.palette.primary.contrastText}`,
                            outlineOffset: -2,
                        },
                    }),
                ...(selectedColor === undefined
                    ? {}
                    : {
                        "&.Mui-selected, &.Mui-selected:hover": {
                            backgroundColor: selectedColor,
                        },
                    }),
            }, children: [_jsx(ListItemIcon, { sx: { color: theme.palette.primary.contrastText }, children: icon }), _jsx(ListItemText, { primary: text })] }) }));
};
/**
 * A simple divider for the application drawer.
 */
export const AppDrawerDivider = Divider;
//# sourceMappingURL=AppDrawerItems.js.map